import { SCHEMA } from '@vedalib/editor/lib/brand'
import { useCallback, useMemo } from 'react'

import Padding from 'components/Editor/Toolbar/Padding'
import { Typography } from 'components/uiKit/Typography'
import { BrandButtonFont, BrandFormFontBase, BrandGoBack } from 'services/Branding/components'
import { FONT_FIELDS } from 'services/Branding/fieldConfigs'
import { genSchema } from 'services/Branding/genSchema'
import { useElementFontCss, useElementFontValues, useUpdateSchema } from 'services/Branding/hooks'
import { BrandFormEnum } from 'services/Branding/types'
import { t } from 'services/Translation'

import type { TabsBrandForms, TabsFormBrandType } from './tabsTypes'

export const FONT_FORM_SCHEMA = genSchema(SCHEMA.tabs.font, {
  selected: FONT_FIELDS.base,
  tabs: FONT_FIELDS.base,
})

const TypographyTabs: TabsFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.tabs}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.tabs.font.tabs')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const TypographySelected: TabsFormBrandType = ({ setForm, device, subConfigs }) => {
  const fontPath = useMemo(() => ['font', device], [device])
  const fontSchema = useUpdateSchema(fontPath, subConfigs, FONT_FORM_SCHEMA)

  const handleSetTypography = useCallback(() => setForm?.(BrandFormEnum.TYPOGRAPHY), [setForm])

  return (
    <BrandFormFontBase font={fontSchema.selected}>
      <BrandGoBack onClick={handleSetTypography}>
        <Typography weight='medium'>{t('elements.tabs.font.selected')}</Typography>
      </BrandGoBack>
      <Typography styleType='hint'>{t('page.brand.fonts.inheritHint')}</Typography>
    </BrandFormFontBase>
  )
}

const TabsTypography: TabsFormBrandType = ({ device, edited, element, setForm }) => {
  const values = useElementFontValues('tabs', device, element?.font)
  const styles = useElementFontCss('tabs', device, element?.font)

  const goBack = useCallback(() => setForm?.(BrandFormEnum.STYLE), [setForm])

  return (
    <Padding bottom gap sides>
      <BrandGoBack onClick={goBack}>
        <Typography weight='medium'>{t('page.brand.tab.typography')}</Typography>
      </BrandGoBack>
      <BrandButtonFont
        edited={edited.font?.tabs}
        font='tabs'
        onClick={setForm}
        styles={styles.tabs}
        values={values.tabs}
      >
        {t('elements.tabs.font.tabs')}
      </BrandButtonFont>
      <BrandButtonFont
        edited={edited.font?.selected}
        font='selected'
        onClick={setForm}
        styles={styles.selected}
        values={values.selected}
      >
        {t('elements.tabs.font.selected')}
      </BrandButtonFont>
    </Padding>
  )
}

const FORM_MAP: TabsBrandForms = {
  [BrandFormEnum.TYPOGRAPHY]: TabsTypography,
  tabs: TypographyTabs,
  selected: TypographySelected,
}

export default FORM_MAP
